const { registerPaymentMethod } 	= window.wc.wcBlocksRegistry;
import EditComponent from './components/Description'
const settings = wc.wcSettings.getPaymentMethodData('ipgw_invoice_gateway')
const options = {
	name: 'ipgw_invoice_gateway',
	content: <EditComponent/>,
	edit: <div>Test </div>,
	canMakePayment: () => true,
	ariaLabel: settings.title,
	label: settings.title,
	supports: {
		features: undefined,
	},
};

registerPaymentMethod( options );

const metadata = {
    "apiVersion": 2,
    "name": "ipgw/invoice-payment-method",
    "version": "1.0",
    "title": "Checkout PO Field",
    "category": "media",
    "description": "",
    "supports": {
        "html": false,
        "align": false,
        "multiple": false,
        "reusable": false
    },
    "parent": ["woocommerce/checkout-shipping-address-block"],
    "attributes": {
        "lock": {
            "type": "object",
            "default": {
                "remove": true,
                "move": true
            }
        }
    },
    "textdomain": "IPGW"
}

const Block = ( { checkoutExtensionData }  )  => {
	const { setExtensionData } = checkoutExtensionData;
	window.setExtensionData = setExtensionData;
    return ('');
}

wc.blocksCheckout.registerCheckoutBlock({
    metadata,
    component: Block,
});